<template>
    <div class="table-wrapper" v-if="patients?.rows">
        <h4> Who is this claim for? </h4>
        <DataTable type="radio" classes="striped small" :table="patients" :selected="patient" @change="handleChange" />
    </div>
    <a href="" class="btn btn-secondary plan-modal add-dependent"
        @click.prevent="handleAdd"> + Add Dependent </a>
</template>

<script lang="ts">
import { PropType, defineComponent, computed } from 'vue';
import { TableData } from '@/interfaces/interfaces';
import { useClaimStore } from '@/stores/claim';
import { useModalStore } from '@/stores/modal';
import { useDependentStore } from '@/stores/dependent';
import DataTable from '@/components/form/DataTable.vue';

export default defineComponent({
    props: {
        patients: [] as PropType<TableData>,
    },
    components: {
        DataTable,
    },
    setup() {
        const claimStore = useClaimStore();
        const patient = computed(() => claimStore.patient)
        const openModal = useModalStore().openModal;

        const handleChange = (event: Event) => {
            const target = event.target as HTMLInputElement | null;

            if (target?.value) {
                claimStore.setPatient(target.value);
            }
        }

        const handleAdd = () => {
            useDependentStore().clearDependent();
            openModal('add-dependent', 'Add Dependent', 'plan-form plan-upload');
        }

        return {
            patient,
            handleChange,
            handleAdd,
            openModal
        }
    }
})
</script>